export const keyMap = {
  ESCAPE: {
    name: /^(Escape|Esc)$/,
    code: 27,
  },
  ENTER: {
    name: /^(Enter|Ent)$/,
    code: 13,
  },
  ARROW_LEFT: {
    name: /^(ArrowLeft|Left)$/,
    code: 37,
  },
  ARROW_RIGHT: {
    name: /^(ArrowRight|Right)$/,
    code: 39,
  },
  BACKSPACE: {
    name: /^Backspace$/,
    code: 8,
  },
  SPACE: {
    name: /^ $/,
    code: 32,
  },
  TAB: {
    name: /^Tab$/,
    code: 9,
  },
};

const testKey = (patternKey, testedKey) => {
  return patternKey.name.test(testedKey) || patternKey.code === testedKey;
};

export const isKey = (patternKeys, event) => {
  if (!(patternKeys && event)) {
    return;
  }
  const testedKey = event.key || event.keyCode;

  if (Array.isArray(patternKeys)) {
    return patternKeys.some((patternKey) => testKey(patternKey, testedKey));
  }

  return testKey(patternKeys, testedKey);
};
